<!-- Template for required field error -->
<ng-template #requiredError let-message>
  <div class="flex items-center text-xs text-red-500">
    <mat-icon class="!h-4 !w-4 !text-xs">error</mat-icon>
    <span class="text-xs">{{ message }}</span>
  </div>
</ng-template>

<!-- Template for email error -->
<ng-template #emailError>
  <div class="-mt-4 flex items-center text-xs text-red-500">
    <mat-icon class="!h-4 !w-4 !text-xs">error</mat-icon>
    <span>No email address</span>
  </div>
</ng-template>

<form class="flex flex-col gap-2" [formGroup]="form">
  <div class="flex flex-col gap-4 md:flex-row">
    <div>
      <span class="mb-1 block text-xs">Type</span>
      <mat-button-toggle-group
        class="!shadow-none"
        formControlName="type"
        aria-label="Referral Type"
      >
        @for (type of referralTypes; track type) {
          <mat-button-toggle [value]="type">
            {{ type | titlecase }}
          </mat-button-toggle>
        }
      </mat-button-toggle-group>
    </div>

    <div class="w-full">
      <p class="!mb-1 text-xs">Patient</p>
      <pr-patient-selector class="w-full" [formControl]="patientCtrl" />

      <div class="-mt-5 flex items-center">
        @if (!formState().patient) {
          <ng-container
            *ngTemplateOutlet="
              requiredError;
              context: { $implicit: 'Patient is required' }
            "
          />
        }
        <span class="flex-1"></span>
        <pr-manage-patient-button
          [patient]="formState().patient"
          (patientChange)="updatePatient($event)"
        />
      </div>
    </div>
  </div>

  <!-- Outgoing Referral Form -->
  @if (typeValue === referralType.Outgoing) {
    <div class="flex flex-col gap-4 md:flex-row">
      <div class="w-full">
        <pr-practitioner-selector
          label="From"
          class="w-full"
          [allowEmpty]="true"
          [disabled]="isDisabled()"
          [staffer]="outgoingReferrer()"
          (stafferSelected)="setReferrerControl($event)"
        />

        @if (!outgoingReferrer()) {
          <div class="-z-10 mt-1 flex items-center">
            <ng-container
              *ngTemplateOutlet="
                requiredError;
                context: { $implicit: 'From is required' }
              "
            />
          </div>
        }
      </div>

      <div class="w-full">
        <pr-contact-selector
          label="To"
          class="w-full"
          [contact]="outgoingRecipient()"
          [disabled]="isDisabled()"
          (contactChanged)="setRecipientControl($event)"
        />
        @if (outgoingRecipient() && !formState().externalUserEmail) {
          <ng-container *ngTemplateOutlet="emailError" />
        }

        @if (!outgoingRecipient()) {
          <div class="-z-10 -mt-4 flex items-center">
            <ng-container
              *ngTemplateOutlet="
                requiredError;
                context: { $implicit: 'To is required' }
              "
            />
          </div>
        }
      </div>
    </div>

    <div class="flex flex-col gap-4 md:flex-row">
      @if (hasMultiplePractices()) {
        <pr-practice-selector
          class="w-full"
          label="From Practice"
          [brands]="[brand()]"
          [practice]="practice()"
          [disabled]="isDisabled()"
          [emitValueOnLoad]="false"
          (practiceSelected)="setPracticeControl($event)"
        />
      }

      <mat-form-field class="w-full">
        <mat-label>Urgency</mat-label>
        <mat-select formControlName="urgency">
          @for (urgency of referralUrgencies; track urgency) {
            <mat-option [value]="urgency">
              {{ urgency | titlecase }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
  }

  <!-- Incoming Referral Form -->
  @if (typeValue === referralType.Incoming) {
    <div class="flex flex-col gap-4 md:flex-row">
      <div class="w-full">
        <pr-contact-selector
          label="From"
          class="w-full"
          [contact]="incomingReferrer()"
          [disabled]="isDisabled()"
          (contactChanged)="setReferrerControl($event)"
        />
        @if (incomingReferrer() && !formState().externalUserEmail) {
          <ng-container *ngTemplateOutlet="emailError" />
        }

        @if (!incomingReferrer()) {
          <div class="-z-10 -mt-4 flex items-center">
            <ng-container
              *ngTemplateOutlet="
                requiredError;
                context: { $implicit: 'From is required' }
              "
            />
          </div>
        }
      </div>

      <div class="w-full">
        <pr-practitioner-selector
          label="To"
          class="w-full"
          [allowEmpty]="true"
          [disabled]="isDisabled()"
          [staffer]="incomingRecipient()"
          (stafferSelected)="setRecipientControl($event)"
        />

        @if (!incomingRecipient()) {
          <div class="-z-10 mt-1 flex items-center">
            <ng-container
              *ngTemplateOutlet="
                requiredError;
                context: { $implicit: 'To is required' }
              "
            />
          </div>
        }
      </div>
    </div>

    <mat-form-field class="w-full">
      <mat-label>Urgency</mat-label>
      <mat-select formControlName="urgency">
        @for (urgency of referralUrgencies; track urgency) {
          <mat-option [value]="urgency">
            {{ urgency | titlecase }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  }
</form>
